import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-debit-cedit-check-dialog',
  templateUrl: './debit-cedit-check-dialog.component.html',
  styleUrls: ['./debit-cedit-check-dialog.component.scss']
})
export class DebitCeditCheckDialogComponent implements OnInit {
  checkedOff = false;
  isDDA = false;
  // Combined total
  useTotal: any = 0;
  // GL totals (default if no DDA data present)
  useGLCredit: any = 0;
  useGLDebit: any = 0;
  useGLTotal: any = 0;
  // DDA totals
  useDDACredit: any = 0;
  useDDADebit: any = 0;
  useDDATotal: any = 0;

  constructor(
    public dialogRef: MatDialogRef<DebitCeditCheckDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    console.log('Debit Credit Check Dialog received data', this.data);
    this.useGLCredit = parseFloat(this.data.credit).toFixed(2);
    this.useGLDebit = parseFloat(this.data.debit).toFixed(2);
    this.useTotal = parseFloat(this.data.total).toFixed(2);

    if (this.data.isDDA) {
      this.isDDA = true;
      this.useDDACredit = parseFloat(this.data.ddaCredit).toFixed(2);
      this.useDDADebit = parseFloat(this.data.ddaDebit).toFixed(2);
      this.useGLTotal = parseFloat(this.data.glTotal).toFixed(2);
      this.useDDATotal = parseFloat(this.data.ddaTotal).toFixed(2);
    }
  }

  closeDialog(dataBoolean: any) {
    this.dialogRef.close(dataBoolean);
  }
  checkIfDisabled() {
    if (this.data.total === 0 || this.checkedOff) {
      return false;
    } else {
      return true;
    }
  }
}
